import {FileUpload} from "primereact/fileupload";
import {Tooltip} from "primereact/tooltip";
import {ProgressBar} from "primereact/progressbar";
import {Tag} from "primereact/tag";
import {Button} from "primereact/button";
import React, {useEffect, useRef, useState} from "react";
import {useParams} from "react-router-dom";
import {UsersService} from "../services/UsersService";
import {Toast} from "primereact/toast";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import {Image} from 'primereact/image'

export default function UserEditDocuments() {

    const props = useParams()
    const toast = useRef(null);
    const [totalSize, setTotalSize] = useState(0);
    const [documents, setDocuments] = useState([]);
    const fileUploadRef = useRef(null);

    const onTemplateSelect = (e) => {
        let _totalSize = totalSize;
        let files = e.files;

        Object.keys(files).forEach((key) => {
            _totalSize += files[key].size || 0;
        });

        setTotalSize(_totalSize);
    };

    const onTemplateUpload = (e) => {
        let _totalSize = 0;

        e.files.forEach((file) => {
            _totalSize += file.size || 0;
        });

        setTotalSize(_totalSize);
        toast.current.show({severity: 'success', summary: 'Файлы загружены'});
        updateFilelist()
    };

    const onTemplateRemove = (file, callback) => {
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateClear = () => {
        setTotalSize(0);
    };

    const headerTemplate = (options) => {
        const {className, chooseButton, uploadButton, cancelButton} = options;
        const value = totalSize / 100000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{backgroundColor: 'transparent', display: 'flex', alignItems: 'center'}}>
                {chooseButton}
                {uploadButton}
                {/*{cancelButton}*/}
                {/*<div className="d-flex align-items-center gap-3 m-l-auto">*/}
                {/*    <span>{formatedValue} / 10 MB</span>*/}
                {/*    <ProgressBar value={value} showValue={false} style={{width: '10rem', height: '12px'}}></ProgressBar>*/}
                {/*</div>*/}
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="d-flex align-items-center flex-wrap justify-content-between">
                <div className="d-flex align-items-center" style={{width: '40%'}}>
                    <img alt={file.name} role="presentation" src={file.objectURL} width={100}/>
                    <span className="d-flex flex-column text-left m-l-30">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Tag value={props.formatSize} severity="warning" className="m-l-30 m-r-30 p-y-2"/>
                <Button type="button" icon="pi pi-times"
                        className="p-button-outlined p-button-rounded p-button-danger ml-auto"
                        onClick={() => onTemplateRemove(file, props.onRemove)}/>
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="d-flex align-items-center flex-column">
                <i className="pi pi-image m-t-3 p-5" style={{
                    fontSize: '2em',
                    borderRadius: '50%',
                    backgroundColor: 'var(--surface-b)',
                    color: 'var(--surface-d)'
                }}></i>
                <span className="my-2">
                    Перетяните сюда файлы
                </span>
            </div>
        );
    };

    const chooseOptions = {
        icon: 'pi pi-fw pi-images',
        iconOnly: true,
        className: 'custom-choose-btn p-button-rounded p-button-outlined'
    };
    const uploadOptions = {
        icon: 'pi pi-fw pi-cloud-upload',
        iconOnly: true,
        className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined'
    };
    const cancelOptions = {
        icon: 'pi pi-fw pi-times',
        iconOnly: true,
        className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined'
    };

    const updateFilelist = () => {
        UsersService.GetDocuments(props.userId).then((r) => {
            if(r && r.length > 0) {
                setDocuments(r)
            }
        })
    }

    const removeDocument = (event, fileId) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Удалить файл?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: (e) => {
                UsersService.RemoveDocument(props.userId, fileId).then((e) => {
                    updateFilelist()
                })
            },
            acceptLabel: 'Удалить',
            rejectLabel: 'Отмена'
        });

    }

    useEffect(() => {
        updateFilelist()
    }, []);


    return (
        <div className={'card'}>
            <Toast ref={toast}></Toast>
            <ConfirmPopup />
            <div className="card-body">
                <Tooltip target=".custom-choose-btn" content="Выбрать файл" position="bottom"/>
                <Tooltip target=".custom-upload-btn" content="Загрузить" position="bottom"/>
                <Tooltip target=".custom-cancel-btn" content="Очистить" position="bottom"/>
                <h3 className={'m-b-30'}>Документы</h3>
                <FileUpload ref={fileUploadRef} name="files[]"
                            url={"http://yii2.easytickets.pro/users/upload?user_id=" + props.userId + "&access-token=" + localStorage.getItem('user')}
                            multiple accept={"image/*,application/pdf,,application/vnd.ms-excel,,application/vnd.ms-word"}
                            onUpload={onTemplateUpload} onSelect={onTemplateSelect} onError={onTemplateClear}
                            onClear={onTemplateClear}
                            headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate}
                            chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions}/>

                <div className={'d-flex flex-column gap-3 m-t-20'}>
                {documents.length > 0 && documents.map((document) => {
                    return (
                        <div className="uploaded-file d-flex align-items-center flex-wrap justify-content-between">
                            <div className="d-flex align-items-center" style={{width: '40%'}}>
                                {document.is_image &&
                                <Image alt={document.name} role="presentation" src={document.public_url} preview/>
                                }
                                {!document.is_image &&   <i className="pi pi-file m-t-3 p-3" style={{
                                    fontSize: '2em',
                                    borderRadius: '10%',
                                    backgroundColor: 'var(--surface-b)',
                                    color: 'var(--surface-d)'
                                }}></i>}
                                <a href={document.public_url} target={'_blank'} className="d-flex flex-column text-left m-l-30">
                        {document.name}.{document.ext}
                                    {/*<small>{new Date().toLocaleDateString()}</small>*/}
                    </a>
                            </div>
                            {/*<Tag value={props.formatSize} severity="warning" className="m-l-30 m-r-30 p-y-2"/>*/}
                            <Button type="button" icon="pi pi-times"
                                    className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={(e) => removeDocument(e, document.id)}/>
                        </div>
                    )
                })}
                </div>
            </div>
        </div>
    )
}